<template>
  <Photos year="2015" :min-date="1427155200" :max-date="1427500800" date-text="March 24&ndash;27" />
</template>

<script setup>
import Photos from "@/components/Photos.vue";
</script>
